<template>
  <div class="promotionObjectives">
    <div class="promotionObjectives_titleArea">
      <h3 class="title">推广目标</h3>
      <span class="tips">选择广告推广的目标，实现你的营销目标</span>
    </div>

    <div class="promotionObjectives_option">
      <ul
        class="option_ul"
      >
        <!-- :class="{active:option1 === name}" -->
        <li
          v-for="value,index in promotionObjectives1"
          :key="index"
          :class="{active:optionname === value.name}"
          class="ul_item"
          @click="toggleOptions(index)"
        >
          <svg
            v-if="value.name === 'PRODUCTTYPE_WECHAT_ARTICLE'"
            viewBox="0 0 48 48"
          >
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M18 12c0-3.3137 2.6863-6 6-6s6 2.6863 6 6v1h4c1.6569 0 3 1.3431 3 3v20c0 1.6569-1.3431 3-3 3H14c-1.6569 0-3-1.3431-3-3V16c0-1.6569 1.3431-3 3-3h4v-1zm2 6.3819c.3069.2747.5.6738.5 1.1181 0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5c0-.4443.1931-.8434.5-1.1181V15h-3.5c-.8284 0-1.5.6716-1.5 1.5v19c0 .8284.6716 1.5 1.5 1.5h19c.8284 0 1.5-.6716 1.5-1.5v-19c0-.8284-.6716-1.5-1.5-1.5H30v3.3819c.3069.2747.5.6738.5 1.1181 0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5c0-.4443.1931-.8434.5-1.1181V15h-8v3.3819zM20 13v-1c0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4v1h-8z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-if="value.name === 'PRODUCTTYPE_LEAD_AD'"
            viewBox="0 0 48 48"
          >
            <path
              data-role="secondary"
              d="M26 19.5a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-1zM26 23.5a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-1zM26.5 27a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5z"
            />
            <path
              data-role="primary"
              d="M20 20.5c0 1.3807-1.1193 2.5-2.5 2.5S15 21.8807 15 20.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5zM13 28.5c0-1.933 1.567-3.5 3.5-3.5h2c1.933 0 3.5 1.567 3.5 3.5v.5c0 .5523-.4477 1-1 1h-7c-.5523 0-1-.4477-1-1v-.5z"
            />
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M7 14c0-1.6569 1.3431-3 3-3h28c1.6569 0 3 1.3431 3 3v20c0 1.6569-1.3431 3-3 3H10c-1.6569 0-3-1.3431-3-3V14zm2 .3519c0-.8285.6716-1.5 1.5-1.5h27c.8284 0 1.5.6715 1.5 1.5v19.2963c0 .8284-.6716 1.5-1.5 1.5h-27c-.8284 0-1.5-.6716-1.5-1.5V14.3519z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-if="value.name === 'PRODUCTTYPE_WECHAT'"
            viewBox="0 0 48 48"
          >
            <path
              data-role="secondary"
              d="M26 22.5a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-1zM26 26.5a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-1zM26.5 30a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5z"
            />
            <path
              data-role="primary"
              d="M13 23c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1h-7c-.5523 0-1-.4477-1-1v-6z"
            />
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M7 13c0-1.6569 1.3431-3 3-3h28c1.6569 0 3 1.3431 3 3v22c0 1.6569-1.3431 3-3 3H10c-1.6569 0-3-1.3431-3-3V13zm2 5v16.5c0 .8284.6716 1.5 1.5 1.5h27c.8284 0 1.5-.6716 1.5-1.5V18H9zm5-4c0 .8284-.6716 1.5-1.5 1.5S11 14.8284 11 14s.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5zm5 0c0 .8284-.6716 1.5-1.5 1.5S16 14.8284 16 14s.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-if="value.name === 'PROMOTED_OBJECT_TYPE_MINI_GAME_WECHAT'"
            viewBox="0 0 48 48"
          >
            <path
              d="M14 8C10.6863 8 8 10.6863 8 14V34C8 37.3137 10.6863 40 14 40H34C37.3137 40 40 37.3137 40 34V14C40 10.6863 37.3137 8 34 8H14ZM14 10C11.7909 10 10 11.7909 10 14V34C10 36.2091 11.7909 38 14 38H34C36.2091 38 38 36.2091 38 34V14C38 11.7909 36.2091 10 34 10H14Z"
              data-role="primary"
              fill-rule="evenodd"
            />
            <path
              d="M30.2844 15.9819C31.3853 15.7003 32.558 16.5194 32.9036 17.8115C33.2491 19.1035 32.6365 20.3792 31.5357 20.6608C30.4346 20.9424 29.2621 20.1231 28.9165 18.8312C28.571 17.5393 29.1834 16.2635 30.2844 15.9819Z"
              data-role="primary"
            />
            <path
              d="M27.543 19.8895C24.7214 17.3252 20.6281 17.2334 18.4005 19.6846C16.1729 22.1357 16.6545 26.2015 19.4761 28.7657C22.2976 31.3302 26.3909 31.4222 28.6187 28.971C30.8461 26.5199 30.3647 22.4539 27.543 19.8895ZM27.3549 23.5821C26.8166 24.5848 25.405 24.8742 24.2019 24.2285C22.9987 23.5827 22.4594 22.2463 22.9974 21.2435C23.5356 20.2408 24.9472 19.9514 26.1506 20.5973C27.3538 21.2431 27.8931 22.5795 27.3549 23.5821Z"
              data-role="primary"
            />
          </svg>
          <span>{{ value.value }}</span>
          <i class="item_icon">√</i>
        </li>
      </ul>
    </div>

    <div
      v-if="option === 'popularizationAndApplication'"
      class="promotionObjectives_Application"
    >
      <div class="Application_item">
        <span class="item_left">应用类型</span>
        <div class="item_right">
          <el-radio
            v-model="radio"
            label="1"
          >ios应用</el-radio>
          <el-radio
            v-model="radio"
            label="2"
          >Android应用</el-radio>
        </div>
      </div>
      <div class="Application_item">
        <span class="item_left">{{ radio === '1' ? 'AppID' : '应用ID' }}</span>
        <div class="item_right">
          <div class="right_input">
            <el-input :placeholder="radio==='1' ? '输入AppID' : '输入腾讯开放平台ID或优量汇ID'" />
            <el-button>校验</el-button>
          </div>
        </div>
      </div>
      <div class="Application_item">
        <span class="item_left">应用名称</span>
        <div class="item_right">
          <span>暂未获取应用名称</span>
        </div>
      </div>
      <div
        v-if="radio !== '1'"
        class="Application_item"
      >
        <span class="item_left">渠道包</span>
        <div class="item_right">
          <el-select
            v-model="value"
            disabled
            placeholder="请选择"
          />
        </div>
      </div>
    </div>

    <div
      v-if="option === 'promoteGames'"
      class="promotionObjectives_Application"
    >
      <div class="Application_item">
        <span class="item_left">小游戏原始id</span>
        <div class="item_right">
          <div class="right_input">
            <el-input :placeholder="'请输入'" />
            <el-button>校验</el-button>
          </div>
        </div>
      </div>
      <div class="Application_item">
        <span class="item_left">小游戏名称</span>
        <div class="item_right">
          <span>暂未获取应用名称</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    promotionObjectives: {
      type: Object
    },
    promotionObjectives1: {
      type: Array
    },
    option: {
      default: ''
    },
    product: {
      type: String
    }
  },
  data() {
    return {
      radio: '1',
      option1: null,
      optionname: ''
    }
  },
  watch: {
    option(newValue) {
      this.option1 = newValue
    }
  },
  created() {
    this.option1 = this.option
    this.optionname = this.product
    console.log('this.product', this.product)
    sessionStorage.setItem('product', this.product)// 存储
  },
  methods: {
    toggleOptions(index) {
      console.log(this.promotionObjectives1[index])
      this.optionname = this.promotionObjectives1[index].name
      this.$emit('setname', this.promotionObjectives1[index].name)
      sessionStorage.setItem('product', this.promotionObjectives1[index].name)
      // if (event.target.nodeName === 'LI') {
      //   this.option1 = event.target.dataset.text
      //   console.log('11', this.option1)
      //   this.$emit('setPromotion', this.option1)
      // } else if (event.target.parentNode.nodeName === 'LI') {
      //   const text = event.target.parentNode.dataset.text
      //   console.log('22', this.option1)
      //   this.option1 = text
      //   this.$emit('setPromotion', this.option1)
      // }
    }
  }
}
</script>

<style scoped lang="less">
.promotionObjectives {
  width: 100%;
  box-shadow: 0 0 0 1px hsla(0, 0%, 87%, 0.5), 0 3px 6px 0 rgba(0, 0, 0, 0.04);
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 25px;
  .promotionObjectives_titleArea {
    padding: 16px 16px 20px 24px;
    margin-bottom: 8px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #1f1f1f;
    }
    .tips {
      margin-top: 4px;
      font-size: 13px;
      color: #6b6b6b;
      display: inline-block;
    }
  }

  .promotionObjectives_option {
    width: 100%;
    .option_ul {
      width: 100%;
      display: flex;
      justify-content: center;

      .ul_item {
        width: 115px;
        height: 115px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px #ebebeb;
        margin: 0px 10px;
        cursor: pointer;
        color: #ccc;
        &.active {
          color: #07c160;
          font-weight: 600;
          background-color: rgba(7, 193, 96, 0.02);
          box-shadow: inset 0 0 0 1px rgb(7 193 96 / 55%);
          svg {
            fill: #07c160;
          }
          .item_icon {
            background-color: #07c160;
            display: flex;
          }
        }
        &:not(.active):hover {
          background-color: #fdfdfd;
          box-shadow: inset 0 0 0 1px #dfdfdf;
          svg {
            fill: #b9b9b9;
          }
          color: #b9b9b9;

          .item_icon {
            display: flex;
          }
        }
        svg {
          width: 48px;
          height: 48px;
          fill: #ccc;
        }
        span {
        }

        .item_icon {
          font-style: normal;
          position: absolute;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background-color: #ccc;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 5px;
          right: 8px;
          display: none;
        }
      }
    }
  }

  .promotionObjectives_Application {
    position: relative;
    box-sizing: border-box;
    padding-left: 42px;
    overflow: hidden;
    transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    padding-top: 42px;

    .Application_item {
      display: flex;
      align-items: center;
      margin: 10px 0px;
      .item_left {
        display: inline-block;
        width: 8em;
        margin-right: 16px;
      }
      .item_right {
        .right_input {
          display: flex;
          button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
